import { apiEndpoint } from '../../_config/config'
import { handleResponse } from '../../_helpers'
import axios from 'axios'
import { localForageService } from '../../_helpers/localforageService'

export const graduates = {
  namespaced: true,
  state: {
    all: [],
    errors: []
  },
  actions: {
    all ({ commit }) {
      const config = {
        method: 'GET',
        url: `${apiEndpoint}/api/frontend/graduates`
      }

      try {
        const saved = localForageService.getItem('graduates')
        if (saved !== null) {
          // If we have a local copy of the graduates commit those now before getting the current results from the server.
          commit('SET_GRADUATES', saved)
        }
      } catch (e) {
        console.log('Error: ', e)
      }

      axios(config).then(handleResponse)
        .then(
          response => {
            commit('SET_GRADUATES', response.result)
          },
          error => {
            commit('ERROR', error)
          }
        )
    }
  },
  mutations: {
    SET_GRADUATES (state, graduates) {
      // console.log(graduates)
      state.all = graduates
      state.errors = []

      try {
        localForageService.setItem('graduates', {
          results: JSON.stringify(graduates)
        })
      } catch (e) {
        console.log('Error: ', e)
      }
    },
    ERROR (state, error) {
      state.errors = error
    }
  },
  getters: {
    getQuotesByLanguage: state => (langId) => {
      var quotes = []
      for (var i = 0; i < state.all.length; i++) {
        var item = state.all[i]
        var quote = item.content.filter((l) => l.language_id === langId)
        quotes.push(quote)
      }

      return quotes
    },
    getAll: state => (langId) => {
      var graduates = []

      for (var i = 0; i < state.all.length; i++) {
        var item = state.all[i]
        if (typeof item.content[langId] !== 'undefined') {
          graduates.push(item.content[langId])
        }
      }

      return graduates
    }
  }
}
